import React, { useContext } from "react";
import { Button } from "antd";
import { HolderOutlined } from "@ant-design/icons";

const DragHandle = ({ context, disabled = false, style, tabIndex = "0" }) => {
  const { setActivatorNodeRef, listeners } = useContext(context);

  return (
    <Button
      tabIndex={tabIndex}
      type="text"
      size="small"
      icon={!disabled ? <HolderOutlined /> : null}
      style={{
        ...style,
        cursor: disabled ? "no-drop" : "move",
        pointerEvents: disabled ? "none" : "auto",
      }}
      ref={setActivatorNodeRef}
      {...listeners}
    />
  );
};

export default DragHandle;
